import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const MailIcon: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 18 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.1294 8.45572C9.69757 8.74361 9.19596 8.8958 8.6788 8.8958C8.16166 8.8958 7.66005 8.74361 7.22822 8.45572L0.11557 3.71381C0.076109 3.6875 0.0376646 3.66008 0 3.63187V11.402C0 12.2929 0.72295 12.9999 1.59788 12.9999H15.7597C16.6505 12.9999 17.3576 12.2769 17.3576 11.402V3.63184C17.3198 3.66011 17.2813 3.6876 17.2418 3.71395L10.1294 8.45572Z"
        fill="currentColor"
      />
      <path
        d="M0.679726 2.8678L7.79237 7.60974C8.06162 7.78925 8.37019 7.87899 8.67876 7.87899C8.98737 7.87899 9.29597 7.78922 9.56522 7.60974L16.6779 2.8678C17.1035 2.58421 17.3576 2.10959 17.3576 1.59734C17.3576 0.716543 16.641 0 15.7603 0H1.59734C0.716577 3.39015e-05 0 0.716577 0 1.59819C0 2.10959 0.254126 2.58421 0.679726 2.8678Z"
        fill="currentColor"
      />
    </svg>
  )
})

MailIcon.displayName = 'MailIcon'
